import { capitalize } from "lodash";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import "twin.macro";

export const Footer: React.FC<{}> = () => {
  const { i18n } = useTranslation();
  const languageSuffix = capitalize(i18n.language);

  const salesTermsFilePath = "/sales_terms_" + languageSuffix + ".pdf";

  return (
    <div tw="flex justify-between p-5 border-t-default border-gray-700 w-auto ml-0">
      <div tw="flex space-x-8 text-gray-900 w-1/4">
        <p tw="py-2 lg:text-sm text-xs">
          PGN International S.r.l.
          <br />
          Via Provinciale del Biagioni, 14
          <br />
          55011 Altopascio - Lucca (LU)
          <br />
          info@palto.it / +39 0583 20325
        </p>
      </div>
      <div tw="flex flex-col items-center justify-center lg:w-full w-1/2">
        <img src="/images/sign-in-logo.png" alt="PGN Showroom" tw="lg:h-12 h-8" />
        <p tw="pt-6 lg:text-sm text-xs">© 2020 - PGN International S.r.l. - Made in Italy by Zoonect</p>
      </div>
      <div tw="flex space-x-8 text-gray-900 w-1/4 justify-end">
        <div tw="flex flex-col lg:text-sm text-xs">
          <Link target="_blank" to={salesTermsFilePath} tw="outline-none hover:(text-gray-600)">
            Cookie Policy
          </Link>
          <Link target="_blank" to={salesTermsFilePath} tw="outline-none hover:(text-gray-600)">
            Privacy Policy
          </Link>
          <Link target="_blank" to={salesTermsFilePath} tw="outline-none hover:(text-gray-600)">
            Terms and Conditions
          </Link>
          <a href="https://www.zoonect.com" target="blank" tw="outline-none hover:(text-gray-600)">
            Credits
          </a>
        </div>
      </div>
    </div>
  );
};
